/*
 * Fifty Five – Content-Reihe. Gehoert zu sections/ff-content.liquid.
 * 1) Pfeile (nur wenn die Spur ueberlaeuft): eine Kartenbreite weiter, disabled am Anfang/Ende.
 * 2) Videos: stumm, spielen nur, solange mindestens die Haelfte sichtbar ist; Pause-Knopf je Video
 *    (WCAG 2.2.2), eine manuelle Pause bleibt bestehen; prefers-reduced-motion = kein Autoplay.
 * 3) Ton (Georg 2026-09-25): standardmaessig stumm; Lautsprecher-Knopf schaltet Ton fuer DIESES Video ein und
 *    alle anderen Videos der Seite stumm. Verlaesst das Video das Bild, pausiert es und ist wieder stumm.
 */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initArrows(root) {
    var track = root.querySelector('[data-ffco-track]');
    var box = root.querySelector('[data-ffco-arrows]');
    if (!track || !box) return;
    var prev = box.querySelector('[data-ffco-prev]');
    var next = box.querySelector('[data-ffco-next]');
    function step() {
      var item = track.querySelector('.ffco__item');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function update() {
      var over = track.scrollWidth > track.clientWidth + 2;
      box.hidden = !over;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function setBtn(btn, paused) {
    btn.classList.toggle('is-paused', paused);
    btn.setAttribute('aria-label', paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
  }

  function initVideos(root) {
    var cards = root.querySelectorAll('.ffco__card--video');
    Array.prototype.forEach.call(cards, function (card) {
      var video = card.querySelector('video');
      var btn = card.querySelector('[data-ffco-toggle]');
      if (!video || !btn) return;
      video.muted = true;
      video.removeAttribute('controls');
      var sound = card.querySelector('[data-ffco-sound]');
      var userPaused = reduced;
      var visible = false;
      setBtn(btn, true);
      function setMuted(m) {
        video.muted = m;
        if (!sound) return;
        sound.classList.toggle('is-muted', m);
        sound.setAttribute('aria-pressed', m ? 'false' : 'true');
        sound.setAttribute('aria-label', m ? sound.dataset.labelOn : sound.dataset.labelOff);
      }
      video._ffcoMute = function () { setMuted(true); };
      if (sound) {
        sound.addEventListener('click', function (e) {
          e.preventDefault();
          var turnOn = video.muted;
          if (turnOn) {
            Array.prototype.forEach.call(document.querySelectorAll('.ffco__card--video video'), function (v) {
              if (v !== video && v._ffcoMute) v._ffcoMute();
            });
            setMuted(false);
            userPaused = false;
            visible = true;
            sync();
          } else {
            setMuted(true);
          }
        });
      }
      function sync() {
        if (visible && !userPaused) {
          var pr = video.play();
          if (pr && pr.catch) pr.catch(function () { setBtn(btn, true); });
          setBtn(btn, false);
        } else {
          video.pause();
          setBtn(btn, true);
          if (!visible) setMuted(true);
        }
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        userPaused = !video.paused;
        if (!userPaused) visible = true;
        sync();
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { visible = en.isIntersecting && en.intersectionRatio >= 0.5; sync(); });
        }, { threshold: [0, 0.5] }).observe(card);
      }
    });
  }

  function init(root) {
    if (!root || root.dataset.ffcoReady === '1') return;
    root.dataset.ffcoReady = '1';
    initArrows(root);
    initVideos(root);
  }
  function scan(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ffco]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
